import { render, staticRenderFns } from "./EstadoCamaras.vue?vue&type=template&id=364c08dc&scoped=true&"
import script from "./EstadoCamaras.vue?vue&type=script&lang=ts&"
export * from "./EstadoCamaras.vue?vue&type=script&lang=ts&"
import style0 from "./EstadoCamaras.vue?vue&type=style&index=0&id=364c08dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c08dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('364c08dc', component.options)
    } else {
      api.reload('364c08dc', component.options)
    }
    module.hot.accept("./EstadoCamaras.vue?vue&type=template&id=364c08dc&scoped=true&", function () {
      api.rerender('364c08dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/EstadoCamaras.vue"
export default component.exports